import { useRentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import TimeConstants from '../../constants/TimeConstants';

const useGetListingPreviewUrl = (listingAlias: string, queryOptions = {}) => {
  return useRentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl(
    { listingAlias },
    {
      enabled: Boolean(listingAlias),
      staleTime: TimeConstants.SECONDS_10,
      ...queryOptions,
    },
  );
};

export { useGetListingPreviewUrl };
